import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_LINKS = [
  { to: "/", label: "首页" },
  { to: "/ranking", label: "人气排行榜" },
  { to: "/genres", label: "题材分类" },
  { to: "/top-rated", label: "高分佳作" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    window.REACT_APP_NAVIGATE(`/genres?q=${encodeURIComponent(q)}`);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 shadow-sm border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] items-center justify-between px-4 md:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="人气韩漫大全首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">
            人气<span className="text-primary-600">韩漫大全</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 lg:gap-2" aria-label="主导航">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium transition-colors ${
                location.pathname === link.to
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <form onSubmit={submitSearch} className="relative" role="search" aria-label="站内搜索">
            <i className="ri-search-line pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索韩漫"
              aria-label="搜索韩漫"
              className="h-10 w-56 rounded-full border border-background-200 bg-background-100/70 pl-9 pr-4 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-300 focus:bg-background-50"
            />
          </form>
          <Link
            to="/top-rated"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            高分佳作
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-800 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <form onSubmit={submitSearch} className="relative px-4 pt-3" role="search" aria-label="站内搜索">
            <i className="ri-search-line pointer-events-none absolute left-7 top-[26px] text-sm text-foreground-400"></i>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索韩漫"
              aria-label="搜索韩漫"
              className="h-10 w-full rounded-full border border-background-200 bg-background-100/70 pl-9 pr-4 text-sm text-foreground-950 outline-none focus:border-primary-300"
            />
          </form>
          <nav className="flex flex-col gap-1 px-3 py-3" aria-label="移动端导航">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-lg px-3 py-2.5 text-sm font-medium ${
                  location.pathname === link.to
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}